angular.module("avlib").filter('avReais', ["$filter", function ($filter) {

	var groupDigits = function(value){
		if (value == null || value == ""){
			return value;
		}else{
			if (value.length > 3){
				var currentGroup = value.substr(value.length-3);
				var nextInput = value.substr(0, value.length-3);
				return groupDigits(nextInput) + "." + currentGroup;
			}else{
				return value;
			}
		}
	};

	return function(value){
		if (value == null){
			return "";
		}

		if (isNaN(value)){
			value = ""+value;
			try{
				value = value.parseFloat();
			}catch(e){
				return null;
			}
		}

		value = value.toFixed(2);
		value = value.replace(".", ",");

		// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
		if (value.length > 6){
			var decimalPart = value.substr(value.length-3);
			var thousandsPart = groupDigits(value.substr(0,value.length-3));
			value =  thousandsPart + decimalPart;
		}

		// Acrescentando o sinal monetário
		value = "R$ " + value;

		return value;
	};
}]);
